import React, { ReactNode, useEffect, useState } from 'react';
import { Image, Platform } from 'react-native';
import { SvgUri } from 'react-native-svg';

interface MissionListLogoProps {
  logoUrl?: string;
  defaultLogo: ReactNode;
  imageStyle: any;
}

const MissionListLogo = ({ logoUrl, defaultLogo, imageStyle }: MissionListLogoProps) => {
  const [hasLoadError, setHasLoadError] = useState(false);

  useEffect(() => {
    setHasLoadError(false);
  }, [logoUrl]);

  const normalizedLogoUrl = logoUrl?.trim();
  const isSvgLogo =
    !!normalizedLogoUrl &&
    (normalizedLogoUrl.toLowerCase().includes('.svg') || normalizedLogoUrl.toLowerCase().startsWith('data:image/svg'));

  if (!normalizedLogoUrl || hasLoadError) {
    return <>{defaultLogo}</>;
  }

  if (isSvgLogo) {
    // Native SVG logo rendering is intermittently crashing in My Missions; keep
    // the same fallback anywhere the shared mission-list logo is used.
    if (Platform.OS !== 'web') {
      return <>{defaultLogo}</>;
    }

    return <SvgUri uri={normalizedLogoUrl} width="100%" height="100%" onError={() => setHasLoadError(true)} />;
  }

  return <Image style={imageStyle} source={{ uri: normalizedLogoUrl }} resizeMode="contain" onError={() => setHasLoadError(true)} />;
};

export default MissionListLogo;
